import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { HEADER_HEIGHT } from 'global/config';
import { FlexColumn, FlexRow } from 'styles/layouts';

export const DropdownList = styled(FlexColumn).attrs(() => ({ as: 'ul' }))`
  width: 100%;
  margin: 0;
  padding: 20px 48px;
  box-sizing: border-box;
  flex-grow: 1;
  flex-shrink: 0;
  align-items: flex-start;
  white-space: nowrap;
  list-style: none;

  li {
    width: 100%;
  }
`;

export const HeaderButton = styled(FlexRow)`
  position: relative;
  gap: 12px;
  align-items: center;
  box-sizing: border-box;

  width: auto;
  cursor: pointer;
  padding: 7px 12px;
  border-radius: ${themeStyle.radiusMedium};
  user-select: none;

  &:hover {
    background-color: ${themeStyle.varInkSuperLight};
  }
`;

export const ItemWrapper = styled.div`
  box-sizing: border-box;
  color: ${themeStyle.varInkMain};
`;

export const HoverBlock = styled.div`
  position: absolute;
  width: 100%;
  top: -50%;
  left: 0;
  height: ${HEADER_HEIGHT}px;
  cursor: pointer;
}`;

export const Wrapper = styled.div`
  padding: 0 4px;
  position: relative;

  margin: 0;
  list-style: none;
  width: 100%;
`;
